jQuery(function ($) {
  var $recommend_projects_json = $("#recommend_projects_json");

  if ($recommend_projects_json.length) {
    var obj = JSON.parse(decodeURIComponent($recommend_projects_json.html().trim()));
    var $well = $("[data-well-project]");

    $.each($well, function (i, val) {
      if (obj[i]) {
        $(val).removeClass("hidden");
        $(val).find(".logo-lg").attr("src", obj[i]["logoPath"]);
        $(val).find("[data-pj_title]").text(obj[i]["pj_title"]);
        $(val).find("[data-datetime]").text(obj[i]["start_ja"].replace("日", "日 "));
      }
    });
  }
});
